// extracted by mini-css-extract-plugin
module.exports = {"shimmer":"Shimmer_shimmer__5gy_C","shimmer-overlay":"Shimmer_shimmer-overlay__9IapX"};